import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NavLink from 'components/NavLink';
import { intl } from 'components/LocaleProvider';
import { FacebookLogin, GoogleLogin } from 'components/UI';
import { useAuth } from 'root/hooks/useAuth';
import { useModal } from 'root/hooks/useModal';

import SignForm from './SignInForm';
import messages from './messages';

const SignInModal = () => {
  const { actionsAuth } = useAuth();
  const { handleOpenModal } = useModal();

  const signIn = (data) => {
    actionsAuth.signIn(data);
  };

  return (
    <div>
      <FacebookLogin action={(data) => signIn(data)} label={intl.formatMessage(messages.labelSignInFacebook)} />
      <GoogleLogin action={(data) => signIn(data)} label={intl.formatMessage(messages.labelSignInGoogle)} />
      <hr className="margin-top-x-medium margin-bottom-x-medium" />
      <div className="align-center position-relative box-text-divider">
        <p style={{ margin: 0 }}>
          <FormattedMessage {...messages.divider} />
        </p>
      </div>
      <SignForm onSubmit={(data) => signIn(data)} />
      <div className="align-center">
        <p>
          <NavLink
            className="highlight grey-border margin-top-small"
            onClick={() => handleOpenModal('signUpModal')}
            dataGoogleInterstitial="false"
          >
            <FormattedMessage {...messages.labelLinkSignUp} />
          </NavLink>
        </p>
      </div>
    </div>
  );
};

SignInModal.propTypes = {
  signIn: PropTypes.func,
};

export default SignInModal;
